import React from 'react';
import { Box } from '@chakra-ui/react';

const GridLayout = ({ children }) => {
  return (
    <Box
      position="relative"
      minHeight="100vh"
      bg="black"
      color="white"
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridAutoRows: 'minmax(100px, auto)',
        '& > *': {
          borderRight: '1px solid rgba(255, 255, 255, 0.1)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }
      }}
    >
      {children}
    </Box>
  );
};

export default GridLayout;